interface Options extends ScrollToOptions {
  offset?: number
}

export function scrollTo(options: Options, element?: HTMLElement) {
  const { top = 0, offset = 0, behavior = 'smooth', ...restOptions } = options || {}
  const targetElement = element || window
  targetElement.scrollTo({
    top: top - offset,
    behavior,
    ...restOptions,
  })
}
